package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class MessageRepository(private val httpClient: HttpClient) {
    suspend fun getMessages(workplaceId: Long): Result<List<MessageDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/messages").body()
    }

    suspend fun sendMessage(workplaceId: Long, req: CreateMessageRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/messages") { setBody(req) }
    }

    suspend fun togglePin(messageId: Long): Result<Unit> = runCatching {
        httpClient.put("messages/$messageId/pin")
    }

    suspend fun deleteMessage(messageId: Long): Result<Unit> = runCatching {
        httpClient.delete("messages/$messageId")
    }
}
